module.exports = __webpack_public_path__ + "media/images/4-487b18340ba6183e6a97bd839f0404fb.jpg";